/**
 * Franja fija que marca un entorno que NO es producción.
 *
 * Existe para un fallo concreto y caro: staging vive en subdominios del
 * mismo dominio y con el mismo diseño que producción, así que es trivial
 * creerse en uno estando en el otro y, por ejemplo, borrar contenido "de
 * prueba" que en realidad era real. La franja hace ese error imposible de
 * pasar por alto.
 *
 * `label` viene del entorno de build de cada app (NEXT_PUBLIC_ENV_LABEL en
 * web/forum, VITE_ENV_LABEL en las SPAs). Vacío o ausente ⇒ no renderiza
 * nada: en producción la etiqueta no se define y el componente desaparece
 * por completo.
 */
export function EnvBanner({ label }: { label?: string | null }) {
  const text = (label ?? "").trim();
  if (!text) return null;
  return (
    <div
      role="status"
      aria-label={`entorno ${text}`}
      style={{
        position: "fixed",
        bottom: 0,
        left: 0,
        right: 0,
        zIndex: 2147483647,
        // Sin pointer-events la franja tragaría clics del contenido que tapa.
        pointerEvents: "none",
        borderTop: "2px solid #ff6b00",
        background: "repeating-linear-gradient(45deg,#ff6b00 0 12px,#1a1a1a 12px 24px)",
        color: "#fff",
        font: "700 11px/1.6 ui-monospace,SFMono-Regular,Menlo,monospace",
        letterSpacing: "0.18em",
        textAlign: "center",
        textShadow: "0 0 4px #000, 0 0 4px #000",
        padding: "2px 0",
      }}
    >
      {text} · DATOS DE PRUEBA
    </div>
  );
}
